import { render, staticRenderFns } from "./l12item.vue?vue&type=template&id=d8c1d10a&scoped=true&"
import script from "./l12item.vue?vue&type=script&lang=js&"
export * from "./l12item.vue?vue&type=script&lang=js&"
import style0 from "./l12item.vue?vue&type=style&index=0&id=d8c1d10a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c1d10a",
  null
  
)

export default component.exports